import React from 'react';
import Button from '../ui/Button';

export interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
}

interface NavigationItem {
  name: string;
  href: string;
  icon?: React.ReactNode;
  current?: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose,
  className = ''
}) => {
  const navigation: NavigationItem[] = [
    { name: 'Home', href: '/', current: true },
    { name: 'Adventures', href: '/adventures', current: false },
    { name: 'Sessions', href: '/sessions', current: false },
    { name: 'Profile', href: '/profile', current: false },
  ];

  return (
    <>
      {/* Desktop sidebar */}
      <div className={`hidden lg:flex lg:flex-shrink-0 ${className}`}>
        <div className="flex flex-col w-64">
          <div className="flex flex-col h-0 flex-1 bg-white border-r border-gray-200">
            <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
              <div className="flex items-center flex-shrink-0 px-4">
                <h2 className="text-lg font-semibold text-gray-900">CoopAdventure</h2>
              </div>
              <nav className="mt-5 flex-1 px-2 space-y-1">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className={`
                      group flex items-center px-2 py-2 text-sm font-medium rounded-md
                      ${item.current
                        ? 'bg-blue-100 text-blue-900'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                      }
                    `}
                  >
                    {item.icon && (
                      <span className="mr-3 flex-shrink-0 h-6 w-6">
                        {item.icon}
                      </span>
                    )}
                    {item.name}
                  </a>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile sidebar */}
      <div 
        className={`
          fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-xl transform transition-transform duration-300 ease-in-out lg:hidden
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          ${className}
        `}
        style={{ backgroundColor: 'white' }}
      >
        <div className="flex flex-col h-full bg-white">
          {/* Header */}
          <div className="flex items-center justify-between px-4 py-4 border-b border-gray-200 bg-white">
            <h2 className="text-lg font-semibold text-gray-900">CoopAdventure</h2>
            <button
              onClick={onClose}
              className="p-2 rounded-md text-gray-600 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xl font-bold"
              aria-label="Close sidebar"
            >
              ✕
            </button>
          </div>
          
          {/* Navigation */}
          <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto bg-white">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className={`
                  group flex items-center px-2 py-2 text-sm font-medium rounded-md
                  ${item.current
                    ? 'bg-blue-100 text-blue-900'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }
                `}
                onClick={onClose}
              >
                {item.icon && (
                  <span className="mr-3 flex-shrink-0 h-6 w-6">
                    {item.icon}
                  </span>
                )}
                {item.name}
              </a>
            ))}
          </nav>
          
          {/* Footer */}
          <div className="p-4 border-t border-gray-200 bg-white">
            <Button
              variant="ghost"
              size="sm"
              fullWidth
              onClick={() => {
                // Handle logout
                onClose();
              }}
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
